import AccordionContainer from "./AccordionContainer";

export default AccordionContainer;
